(() => {
class DevilryCollectionIntro extends HTMLElement {
  connectedCallback() {
    requestAnimationFrame(() => { if (this.isConnected) this.cleanText(); });
  }
  cleanText() {
    const decorative = ["🕷️", "🕯️", "⚰️", "⚔️", "🧢", "🎄", "😈", "🦴", "🧒", "🪡", "🖤", "🤘", "🦄", "💀", "☕", "🔥", "📸", "⚡", "🌌", "🤠"];
    this.querySelectorAll('.collection-hero__title, .collection-hero__description').forEach(region => {
      const walker = document.createTreeWalker(region, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) if (!walker.currentNode.parentElement.closest('script, style, noscript')) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        let text = node.textContent;
        decorative.forEach(symbol => { text = text.replaceAll(symbol, ''); });
        if (text !== node.textContent) node.textContent = text;
      });
    });
  }
}
if (!customElements.get('devilry-collection-intro')) customElements.define('devilry-collection-intro', DevilryCollectionIntro);
})();
